import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
    selector: 'tt-bank-reconciliation-analysis',
    templateUrl: './bank-reconciliation-analysis.component.html',
    styleUrls: ['./bank-reconciliation-analysis.component.css'],
    standalone: false
})
export class BankReconciliationAnalysisComponent implements OnInit {
    businessCoBankAccountKeyno;

    public setting?: BankReconciliationGet;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.businessCoBankAccountKeyno = this.stateService.getStateParams()['businessco_bankaccount_keyno'];
    }

    private async loadSetting() {
        if (!!this.businessCoBankAccountKeyno) {
            this.setting = (await this.datatask.Post(3376, { businessco_bankaccount_keyno: this.businessCoBankAccountKeyno }))[0];
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('bankreconciliationanalysis_analysis_grid')
                .setLoadDataFunction({
                    method: 3738,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof BankReconciliationGet) {
        if (!this.setting) return;

        switch (id) {
            case 'balance_date':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface BankReconciliationGet {
    businessco_bankaccount_keyno: string;
    bankaccount_name: string;
    account_no_ocr: string;
    bankaccount: string;
    businessco_no: string;
    company_name: string;
    balance_bank: string;
    balance_acledger: string;
    balance_date: string;
    account_no_and_name: string;
    show_transaction_details: string;
    account_no_bank_fees: string;
    show_reset_match: string;
    warning_message: string;
    bankreconciliation_start_date: string;
    searchtext_bank: string;
    searchtext_acledger: string;
}
